<template>
	<div id='ediotitem'>
		<a-popover :visible="shShowBol" placement="left" :destroyTooltipOnHide="true" trigger="click"
			@visibleChange="shEvent()" :overlayStyle="{width:'calc(17rem + 32px)'}"
			:getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
			<template slot="content">
				<div class="tableBzView">
					<div class="tableBzViewTitle">備 註</div>
					<div style="padding:0rem 0.8rem 0.3rem;width:100%;">
						<div class="tableBzViewList">
							<a-collapse style="background-color:#fcfcfc;" expandIconPosition="right" :accordion="true"
								:bordered="false">
								<div style="max-height: 300px;overflow: auto;margin-top: .5rem;">
									<div v-for="(item,index) in tableData" :key="index" v-if='tableData.length'>
										<span style="font-weight: bold;font-size:0.75rem;">{{item.remark}}</span>
										<p style="text-align: right;">{{ item.createtime }}</p>
										<a-divider v-if='index + 1 < tableData.length' style='margin: .5rem 0;' />
									</div>
								</div>
							</a-collapse>
						</div>
					</div>
				</div>
			</template>
			<img :src="shShowBol ? icon_bianji1 : icon_bianji" class="imageC">
		</a-popover>
	</div>
</template>

<script>
	import App from '@/assets/app.js';
	import icon_bianji from '@/image/icon_wenjian.png';
	import icon_bianji1 from '@/image/icon_wenjian1.png';
	export default {
		props: ['record'],
		data() {
			return {
				icon_bianji,
				icon_bianji1,
				shShowBol: false,
				tableData: [],
				popconfirm3Bol: false,
				popconfirm2Bol: false,
				popconfirm1Bol: false,
				aduit: false,
				textareaValue: ''
			}
		},
		methods: {
			visibleShow(record, type) {
				console.log('------------2')
			},
			shTgEvent(record, type) { //1通過  //2拒絕
			 if(this.record.readingflag !== 1){
				App.oTool.warningT('請先查看PDF');
				return
			}
				if (!this.textareaValue) {
					if (type == 1) {
						this.textareaValue = '審核通過'
					} else if (type == 2) {
						App.oTool.warningT('請填寫備註信息');
						return
					}
				}

				this.$ajax({
					method: 'post',
					url: this.$api.newAttenceApplyAudit,
					data: {
						"applyid": this.record.applyid,
						token: this.$store.state.token,
						 "handle":type, //1 審核通過 2審核拒絕
						 "remark":this.textareaValue  //備註
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						App.oTool.successT();
						this.$emit('child', true);
						this.shShowBol = false;
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			getdata() {
				this.textareaValue = ''
				this.$ajax({
					method: 'post',
					url: this.$api.getlook,
					data: {
						"flag":"domainname",
						 "domainnameid":this.record.domainnameid
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.tableData = res.data.OtherSystemLogList;
						// this.$emit('child', true);
						this.shShowBol = !this.shShowBol;
					}
				})
			},
			//第二操作
			shEvent() {
				if (this.shShowBol) {
					this.shShowBol = !this.shShowBol
				} else {
					this.getdata()
				}
			},
		}
	}
</script>

<style lang='scss' scoped>
	#ediotitem {
		.p1 {
			div {
				float: right;
			}
		}

		.tableBzViewBtn {
			margin: 0 3rem !important;
		}
	}
</style>
